const { RichText, InnerBlocks } = wp.blockEditor;
const { Component } = wp.element;

import Inspector from './inspector';

const ALLOWED_BLOCKS_CTA = ['core/button'];

const CTA_TEMPLATE  =   [
    ['core/button', {}]
];

class Edit extends Component {

	render() {
		
    const { attributes, setAttributes } = this.props;
    console.log(attributes);

    return([
		<Inspector {...this.props} />
        ,

            <div className="cta-container"
            	 style={{ backgroundImage: Object.keys(attributes.bgImage).length === 0 ? "none" : `url(${attributes.bgImage.url})` }} >
	            <div className="cta-overlay" style={ { background: attributes.overlayColor, opacity: attributes.overlayOpacity } }>
	            </div>

				<RichText key="editable"
				        tagName="p"
				        placeholder="CTA Text"
				        value={ attributes.body }
				        onChange={ (newText) => setAttributes({body: newText}) }
				        style={ { color: attributes.bodyColor } } />
				
				<InnerBlocks allowedBlocks={ ALLOWED_BLOCKS_CTA } template={ CTA_TEMPLATE } orientation="horizontal" templateLock="all" />
            </div>
        ])
    }
    
}


export default Edit;
